// import React from "react";
// import SideBar from "../SideBar/SideBar";
// import { Outlet } from "react-router-dom";
// import { Box, CircularProgress, useMediaQuery, useTheme, } from "@mui/material";
// import { useAuth } from "../../../src/contexts/AuthContext";
// export default function MainLayout() {
//   const theme = useTheme();
//   const isMobile =
//     useMediaQuery(
//       theme.breakpoints.down("md")
//     );

//   const { user, loading, isGuest, } = useAuth();
//   const guestUser = isGuest || user?.isGuest === true || user?.isGuest === "true" || user?.roleName === "Guest" || user?.roles?.includes("Guest");
//   if (loading) {
//     return (
//       <Box sx={{ minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", background: "#09051a", }} >
//         <CircularProgress
//           size={30}
//           sx={{ color: "#58FF71", }}
//         />
//       </Box>
//     );
//   }

//   if (guestUser) {
//     return (
//       <Box sx={{ width: "100%", minWidth: 0, minHeight: "100dvh", backgroundColor: "#09051a", overflowX: "hidden", }} >
//         <Box component="main" sx={{ width: "100%", minWidth: 0, minHeight: "100dvh", margin: 0, padding: 0, overflowX: "hidden", "& > *": { maxWidth: "100%", }, }} >
//           <Outlet />
//         </Box>
//       </Box>
//     );
//   }
//   return (
//     <Box sx={{ display: "flex", width: "100%", minHeight: "100dvh", backgroundColor: "#1f2937", overflowX: "hidden", }} >
//       <SideBar />
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           minWidth: 0,
//           width: { xs: "100%", md: "calc(100% - 1%)", },
//           marginLeft: { xs: 0, md: "1%", },
//           padding: { xs: "80px 16px 20px", sm: "80px 20px 24px", md: "1rem", lg: "1.25rem", },
//           overflowX: "hidden",
//           transition: "all 0.3s ease",
//           boxSizing: "border-box",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

import SideBar from "../SideBar/SideBar";
import { Outlet } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";

export default function MainLayout() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box sx={{ display: "flex", minHeight: "90vh", backgroundColor: "#1f2937" }}>
            <SideBar />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    marginLeft: isMobile ? 0 : "1%", // Only the drawer width
                    padding: isMobile ? "80px 16px 20px 16px" : "1rem", // Match sidebar margin for consistency
                    width: isMobile ? "100%" : "99%", // Remaining width
                    overflowX: "hidden",
                    transition: "all 0.3s ease",
                }}
            >
                <Outlet />
            </Box>
        </Box>
    );
}
